import React, { useState } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton
} from '@mui/material';
import { Facility } from './types';
import { Delete, Edit } from '@mui/icons-material';
import { useFormContext } from './FormContext';

interface Props {
    setOpenEditForm: (e: boolean) => void;
    setFacilityToEdit: (facility: Facility | null) => void;
    setFacilityIndex: (e: number | null) => void;
}

const FacilitiesChart = ({ setOpenEditForm, setFacilityToEdit, setFacilityIndex }: Props) => {
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
    const { formData, setFormData } = useFormContext();

    const handleOpenDeleteDialog = (index: number) => {
        setDeleteIndex(index);
        setOpenDeleteDialog(true);
    };

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
        setDeleteIndex(null);
    };

    const handleConfirmDelete = () => {
        if (deleteIndex !== null) {
            const updatedFacilities = formData.facilities.filter((_, i) => i !== deleteIndex);
            setFormData((prev) => ({
                ...prev,
                facilities: updatedFacilities,
            }));
        }
        handleCloseDeleteDialog();
    };

    const handleEdit = (index: number) => {
        const facilityToEdit = formData.facilities[index];
        setFacilityToEdit(facilityToEdit);
        setFacilityIndex(index);
        setOpenEditForm(true);
    };

    return (
        <>
            <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                <Table aria-label="facilities table" sx={{ width: '100%' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Address</TableCell>
                            <TableCell>Shipping Contact</TableCell>
                            <TableCell>Shipping Contact Phone</TableCell>
                            <TableCell>Shipping Contact Email</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {formData.facilities.map((facility, index) => (
                            <TableRow key={index}>
                                <TableCell>{facility.businessInfo.facilityName}</TableCell>
                                <TableCell>
                                    {facility.businessInfo.address}, {facility.businessInfo.city}, {facility.businessInfo.state} {facility.businessInfo.zip}
                                </TableCell>
                                <TableCell>
                                    {facility.shippingInfo.contact?.firstName} {facility.shippingInfo.contact?.lastName}
                                </TableCell>
                                <TableCell>{facility.shippingInfo.contact?.phone}</TableCell>
                                <TableCell>{facility.shippingInfo.contact?.email}</TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleEdit(index)} color="primary"><Edit /></IconButton>
                                    <IconButton onClick={() => handleOpenDeleteDialog(index)} color="error"><Delete /></IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>Are you sure you want to delete this facility?</DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDeleteDialog} color="primary">Cancel</Button>
                    <Button onClick={handleConfirmDelete} color="error">Delete</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default FacilitiesChart;
